import { Cookies } from 'react-cookie';

import { ChangeTrapLocationFormValues } from './types';

import axiosInterceptor from 'api/interceptor/axiosClient';

export interface PutHubNewLocationInterface {
  slug: string;
  action: 'new_place' | 'adjustment';
  plan_id?: number;
  newLocationData: ChangeTrapLocationFormValues;
}

export const putHubNewLocation = async ({ slug, action, newLocationData, plan_id }: PutHubNewLocationInterface) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const data = await axiosInterceptor.put(
    `/hubs/${slug}/location/${action}`,
    {
      ...newLocationData,
    },
    {
      params: {
        plan_id,
      },
      headers: {
        Authorization: token,
      },
    },
  );

  return data.data as any;
};
